<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'app'
}
</script>

<style>
#app {
  height: 100%;
}

body {
  height: 100vh;
  margin:0;
}
</style>
